import { Accordion, AccordionDetails, AccordionSummary, SxProps, styled } from '@mui/material';

export const CustomAccordion = styled(Accordion)<{
	islast?: boolean;
}>(({ islast }) => ({
	borderBottomLeftRadius: '0px !important',
	borderBottomRightRadius: '0px !important',
	borderBottom: islast ? 'none' : '1px solid #E2E2E2',
	backgroundColor: 'transparent',
}));

export const CustomAccordionSummary = styled(AccordionSummary)<{
	isfirst?: boolean;
}>(({ isfirst, theme }) => ({
	fontSize: 'var(--font-size-default)',
	fontWeight: 'bold',
	borderTop: isfirst ? '1px solid #E2E2E2' : 'none',
	padding: '0px',
	[theme.breakpoints.down('md')]: {
		fontSize: 'var(--font-size-caption)',
	},
}));

export const CustomAccordionDetails = styled(AccordionDetails)(() => ({
	fontSize: 'var(--font-size-body) !important',
    paddingTop: '4px',
    paddingLeft: '0px',
}));

export const TitleSX: SxProps = {
	fontSize: 'var(--font-size-body)',
	fontWeight: '600',
	pt: { xs: '15px', sm: '21px' },
	pb: { xs: '15px', sm: '21px' },
	color: '#2a2a2a',
};
